<script>
import TwConfirmDialog from '../../components/TwConfirmDialog';

export default {
  components: {
    TwConfirmDialog,
  },
  props: {
    displayTitle: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    src: {
      type: String,
      required: true,
    },
    thumbnail: {
      type: String,
      required: true,
    },
  },
  computed: {
    changed() {
      return this.title !== this.formTitle;
    },
  },
  methods: {
    remove() {
      this.confirm = false;
      this.toggled = false;
      this.$emit('remove');
    },
    toggle() {
      this.$refs.dialog.open();
    },
    reset() {
      this.formTitle = this.title;
    },
    update() {
      this.toggled = false;
      this.$emit('update', {
        title: this.formTitle,
      });
    },
  },
  data() {
    return {
      toggled: false,
      image: null,
      height: null,
      width: null,
      confirm: false,
      formTitle: null,
    };
  },
  created() {
    this.formTitle = this.title;
    this.image = new Image();
    this.image.src = this.src;
    this.image.addEventListener('load', () => {
      this.height = this.image.height;
      this.width = this.image.width;
      this.width = this.width > 500 ? this.width : 500;
    });
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    :max-width="width"
  >
    <template v-slot:activator="{ on }">
      <v-flex class="itinerary-day-program-image-title">
        <span v-if="displayTitle">{{ title }}</span>
        <span v-else>{{ $t('itinerary.edit.dayProgram.images.preview') }}</span>
      </v-flex>
      <v-img
        v-on="on"
        :src="thumbnail"
        class="itinerary-day-program-image-toggle"
        min-width="100%"
        min-height="100%"
        max-width="100%"
        max-height="100%"
        position="center center"
      />
    </template>
    <template>
      <v-card>
        <v-flex font-weight-bold pa-3 title>
          <v-icon>image</v-icon>
          <span>{{ $t('itinerary.edit.dayProgram.images.preview') }}</span>
        </v-flex>
        <v-divider light/>
        <v-flex pa-3>
          <v-text-field
            v-if="displayTitle"
            :label="$t('snowGuarantee.labels.title')"
            v-model="formTitle"
            clearable
          />
          <v-img
            :src="src"
            :height="height"
            :width="width"
            max-width="100%"
            contain
          />
        </v-flex>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="toggle"
            color="red"
            flat
          >
            {{ $t('buttons.delete') }}
          </v-btn>
          <v-btn
            @click="toggled = false"
            color="primary"
            flat
          >
            {{ $t('buttons.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
    <template>
      <tw-confirm-dialog
        ref="dialog"
        :title="$t('dialog.delete.title')"
        :description="$t('dialog.delete.text')"
        @confirm="remove"
      />
    </template>
  </v-dialog>
</template>

<style lang="scss">
  @import '../../assets/scss/mixins';
  @import '../../assets/scss/variables';

  .itinerary-day-program-image-title {
    @include position-absolute();
    font-size: $font-size-md;
    z-index: 10;
    color: white;
    margin: $margin-xs;
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
  }

  .itinerary-day-program-image-toggle {
    cursor: pointer;
    opacity: 1;
    transition: .2s opacity ease;

    &:hover {
      opacity: .8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramImage.vue